module.exports = __webpack_public_path__ + "static/media/ic_categories_accessary.3ec3b187.svg";